export const LINKS = {
  en: {
    creator: "/creator",
    order: "/order"
  },
  pl: {
    creator: "/kreator",
    order: "/zamowienie"
  },
  fr: {
    creator: "/createur",
    order: "/ordre"
  },
  de: {
    creator: "/schopfer",
    order: "/bestellen"
  },
  it: {
    creator: "/creatore",
    order: "/ordine"
  },
  sk: {
    creator: "/tvorca",
    order: "/objednat"
  },
  se: {
    creator: "/skapare",
    order: "/ordning"
  },
  nl: {
    creator: "/schepper",
    order: "/bestellen"
  }
};
